import { handleFreeReturn } from '@lambda/commons/helpers';
import settings from '@/settings';
import buyer from '@/public/icons/homepage/marketplace/buyer.svg';
import quality from '@/public/icons/homepage/marketplace/quality.svg';
import saving from '@/public/icons/homepage/marketplace/saving.svg';
import { t } from './helpers';

const freeReturnDays = handleFreeReturn(
  settings.store,
  settings.free_return_days,
);

export const CATEGORY_CONTENT = {
  baby: {
    title: 'Your Marketplace for Sustainable Baby Gear',
    subTitle: '',
    usps: [
      {
        title: 'Save Up To 70%',
        desc: `Priced just right. Find the best deals for your ${t(
          'favorite',
        )} ${t(
          'used',
        )} and certified renewed strollers, wagons, high chairs, feeding supplies, nursery essentials, and more.`,
        icon: saving,
      },
      {
        title: `${freeReturnDays} Day Free Returns`,
        desc: `We guarantee satisfaction. All ${t(
          'used',
        )} and certified renewed baby products are thoroughly inspected and have a ${
          settings.store === 'reebelo-us' ? 3 : settings.warranty_month
        }-month warranty. Not satisfied? Enjoy free ${freeReturnDays}-day returns.`,
        icon: buyer,
      },
      {
        title: `High Safety Standards`,
        desc: `All over-stock, open-box, and ${t(
          'used',
        )} baby gear is held to high standards with professional cleaning, ${t(
          'sanitizing',
        )}, and thorough safety checks by certified technicians.`,
        icon: quality,
      },
    ],
  },
  'sports-and-fitness': {
    title: 'Your Marketplace for Sustainable Sports Equipment',
    subTitle: '',
    usps: [
      {
        title: 'Save Up To 70%',
        desc: `Priced just right. Find the best deals for your ${t(
          'favorite',
        )} ${t(
          'used',
        )} and certified refurbished bikes, tennis rackets, ski gear, gold clubs, baseball mitts, running shoes, and more.`,
        icon: saving,
      },
      {
        title: `${freeReturnDays} Day Free Returns`,
        desc: `We guarantee satisfaction. All ${t(
          'used',
        )} and certified renewed sporting gear and equipment listed on the site are thoroughly inspected for 100% functionality. Not satisfied? Enjoy free ${freeReturnDays}-day returns.`,
        icon: buyer,
      },
      {
        title: `High Safety Standards`,
        desc: `All ${t(
          'used',
        )} sports and fitness products are held to high standards with professional cleaning, ${t(
          'sanitizing',
        )}, and thorough safety checks by certified technicians.`,
        icon: quality,
      },
    ],
  },
  'power-tools': {
    title: 'Your Marketplace for Sustainable Power Tools',
    subTitle: '',
    usps: [
      {
        title: 'Save Up To 70%',
        desc: `Priced just right! Discover the best deals for your ${t(
          'favorite',
        )} ${t(
          'used',
        )} and certified refurbished power tools. Whether you're in need of drills, saws, sanders, wrenches, grinders, or more.`,
        icon: saving,
      },
      {
        title: `${freeReturnDays} Day Free Returns`,
        desc: `We guarantee satisfaction. All ${t(
          'used',
        )} and certified renewed power tools listed on the site are thoroughly inspected for 100% functionality. Not satisfied? Enjoy free ${freeReturnDays}-day returns.`,
        icon: buyer,
      },
      {
        title: `High Safety Standards`,
        desc: `All refurbished and ${t(
          'used',
        )} power tools are held to high standards with professional cleaning, ${t(
          'sanitizing',
        )}, and thorough safety checks by certified technicians.`,
        icon: quality,
      },
    ],
  },
};
